<template>
  <div class="v-text-field-extended">
    <v-text-field
      v-bind="$attrs"
      v-on="$listeners"
      v-model="internalValue"
    />
    <v-progress-circular
      class="v-text-field-extended__spinner"
      v-if="loading"
      :size="20"
      indeterminate
    />
  </div>
</template>

<script>
export default {
  name: 'VTextFieldExtended',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value (value) {
      this.internalValue = value
    }
  }
}
</script>

<style lang="scss" scoped>
.primary--text /deep/ input {
  caret-color: var(--primary_text) !important;
}

.v-text-field-extended {
  position: relative;

  &__spinner {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  /deep/ {
    .input-group--focused .icon {
      color: rgba(0, 0, 0, 0.54) !important;
    }

    .input-group--text-field__suffix {
      color: rgba(0, 0, 0, 0.38) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vuetify/VTextFieldExtended.vue